module.exports = __webpack_public_path__ + "mn.f5fbbc95f3b25a033057.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/mn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/mn.svg
// module chunks = styles